import { useEffect } from "react";

const ArticleOne = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="pt-32 px-5 pb-20 w-full flex flex-row justify-center">
      <div style={{ maxWidth: 1200 }}>
        <h1
          style={{ color: "#8C191B" }}
          className="text-center lg:text-2xl underline pb-4"
        >
          TECHNICAL SUPPORT AGREEMENTS (TSAS): LEGAL REQUIREMENTS
        </h1>
        <b style={{ color: "#8C191B" }}>Introduction</b>
        <p>
          On 25 April 2025, Tanzania introduced the Mining (Technical Support to
          Holders of Primary Mining Licences) Regulations, 2025 (G.N. No. 260).
          These regulations allow Primary Mining Licence (PML) holders to enter
          into legally recognized Technical Support Agreements (TSAs) with
          qualified individuals or entities to enhance mining operations.
        </p>
        <p className="pt-4">
          This update summarizes the legal requirements for TSAs and what
          stakeholders need to know.
        </p>
        {/* segment two Who Qualifies as a Technical Support Provider*/}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>
            Who Qualifies as a Technical Support Provider?
          </p>
          <p>A Technical Support Provider (TSP) may be:</p>
          <ul className="list-disc list-inside">
            <li>
              A Tanzanian citizen or company with relevant expertise or capital;
              or
            </li>
            <li>
              A foreign entity, only if the required services are not available
              locally, subject to the Mining Commission approval.
            </li>
          </ul>
          <p>
            All providers must comply with the Mining (Local Content)
            Regulations, 2018.
          </p>
        </div>
        {/* segment three Key TSA Requirements */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Key TSA Requirements</p>
          <p>Every TSA must:</p>
          <ul className="list-disc list-inside">
            <li>Be in writing, in Kiswahili or English</li>
            <li>Be signed by both parties</li>
            <li>
              Clearly define the scope of services (e.g., financing, equipment
              supply, training, technical advice)
            </li>
            <li>Cover a maximum of 10 tenements</li>
            <li>
              Have a term of up to 3 years (renewable, maximum total duration of
              10 years)
            </li>
            <li>
              Be registered with the Mining Commission before taking effect
            </li>
          </ul>
        </div>
        {/* segment Approval & Oversight*/}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Approval & Oversight</p>
          <ul className="list-disc list-inside">
            <li>
              TSAs must be submitted to and approved by the Mining Commission
              (HQ or Zonal Offices).
            </li>
            <li>
              The Commission will assess the competence of the TSP and verify
              compliance with mining laws.
            </li>
            <li>
              Ongoing inspections may be conducted to ensure proper
              implementation.
            </li>
            <li>The Commission may suspend or revoke uncompliant TSAs.</li>
          </ul>
        </div>
        {/* segment Compliance Risk*/}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Compliance Risk</p>
          <p>
            Failure to register a TSA or engaging in informal support
            arrangements may result in:
          </p>
          <ul className="list-disc list-inside">
            <li>Suspension or cancellation of the PML</li>
            <li>Monetary penalties</li>
            <li>Blacklisting of the support provider</li>
          </ul>
        </div>
        {/* segment  Implications for Stakeholders*/}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Implications for Stakeholders</p>
          <p>
            PML Holders: A legal opportunity to access technical expertise,
            equipment, and financing. Ensure all partnerships are formalized and
            compliant.
          </p>
          <p>
            - Investors / Providers: A new legal gateway to partner with
            small-scale miners in Tanzania. Must adhere to local content
            obligations and secure Commission approval.
          </p>
        </div>
        {/* segment  How We Can Help*/}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>How We Can Help</p>
          <p>We support clients with:</p>
          <ul className="list-disc list-inside">
            <li>Drafting & reviewing TSAs</li>
            <li>Compliance assessments</li>
            <li>Partner due diligence</li>
            <li>Registration with the Mining Commission</li>
            <li>Local content advisory</li>
          </ul>
        </div>
        <br />
        <i style={{ color: "#8C191B" }}>
          "This legal update is provided for general information purposes and
          does not constitute any legal advice. For tailored legal advice,
          please contact our team for assistance."
        </i>
      </div>
    </div>
  );
};

export default ArticleOne;
